import React from 'react';
import { useHistory } from 'react-router-dom';
import { isNativeApp } from '../../util/platformDetection';

const ContactMobile = () => {
  const history = useHistory();

  return (
    <div style={{
      width: '100vw',
      height: 'calc(100dvh - 55px)', // Account for bottom navigation
      backgroundColor: '#000',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      paddingTop: 'env(safe-area-inset-top)', // iPhone notch safe area
      paddingBottom: 'env(safe-area-inset-bottom)' // iPhone gesture area
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: '#1a1a1a',
        borderBottom: '1px solid #333',
        padding: '15px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <h2 style={{
          color: 'gold',
          margin: 0,
          fontSize: '24px',
          fontWeight: 'bold'
        }}>
          Contact Us
        </h2>
        <button
          onClick={() => history.goBack()}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: '#888',
            fontSize: '28px',
            cursor: 'pointer',
            padding: '5px'
          }}
        >
          ✕
        </button>
      </div>

      {/* Content */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        padding: '15px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <div style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '8px',
          padding: '20px',
          border: '1px solid #333',
          width: '100%',
          textAlign: 'center',
          boxSizing: 'border-box'
        }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '20px',
            color: 'gold'
          }}>
            <i className="fa-solid fa-envelope"></i>
          </div>
          
          <h3 style={{
            color: 'gold',
            fontSize: '20px',
            fontWeight: 'bold',
            marginBottom: '20px'
          }}>
            Get in Touch
          </h3>

          <p style={{
            color: '#ccc',
            fontSize: '16px',
            lineHeight: '1.5',
            marginBottom: '30px'
          }}>
            For all inquiries, including support, billing, and questions about advertising chess on our platform, please contact:
          </p>

          <div
            style={{
              display: 'inline-block',
              padding: '15px 30px',
              backgroundColor: 'gold',
              color: 'black',
              fontSize: '18px',
              fontWeight: 'bold',
              textDecoration: 'none',
              borderRadius: '8px',
              marginBottom: '20px'
            }}
          >
            info@chessthread.com
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContactMobile;